import {Button, Icon} from '@flexe/ui-components';
import * as React from 'react';
import {useEffect, useState} from 'react';

const FreshnessCounter = ({isShipper}) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const MAX_MINUTES = 5;
  const MAX_SECONDS = MAX_MINUTES * 60;

  useEffect(() => {
    if (isShipper || elapsedSeconds >= MAX_SECONDS) {
      return;
    }

    const intervalId = setInterval(() => {
      setElapsedSeconds((prevSeconds) => {
        if (prevSeconds < MAX_SECONDS) {
          return prevSeconds + 1;
        }
        clearInterval(intervalId); // Stop interval once max time is reached
        return prevSeconds;
      });
    }, 1000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [elapsedSeconds]);

  const handleRefresh = () => {
    window.location.reload();
  };

  const formatTime = (seconds: number) => {
    if (seconds >= MAX_SECONDS) {
      return `Over ${MAX_MINUTES} Minutes`;
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const paddedSeconds = String(remainingSeconds).padStart(2, '0');
    return `${minutes}:${paddedSeconds}`;
  };

  if (isShipper) {
    return null; // Don't render timer if isShipper is true
  }

  return (
    <div className="freshness-counter">
      <span>{formatTime(elapsedSeconds)}</span>
      <span>Since Last Refresh</span>
      <Button label="refresh" visualType="icon" onPress={handleRefresh}>
        <Icon icon="refresh" />
      </Button>
    </div>
  );
};

export default FreshnessCounter;
